/**
 * Date formatter utility functions for sales-checkin application
 */

export const shortDateString = (_date: Date): string => '';
